import { styled } from "styled-components";

export const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]};
  padding: ${({ theme }) => theme.spacing[4]} ${({ theme }) => theme.spacing[4]};
  margin: ${({ theme }) => theme.spacing[4]} 0;
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  border-left: 3px solid
    ${({ theme }) => theme.colors.button.primary.background};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: ${({ theme }) => theme.spacing[3]};
  }
`;

export const BannerIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  min-width: 36px;
  height: 36px;
  border-radius: ${({ theme }) => theme.spacing[1]};
  background-color: ${({ theme }) => theme.colors.button.primary.background};
  color: white;
`;

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const BannerTitle = styled.span`
  font-size: ${({ theme }) => theme.fonts.base.fontSize};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary.color};
`;

export const BannerDescription = styled.span`
  font-size: ${({ theme }) => theme.fonts.sm.fontSize};
  color: ${({ theme }) => theme.colors.text.secondary.color};
`;
